import React, { useState, useEffect } from 'react';
import { Fab, useTheme, Zoom } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';
import { keyframes } from '@emotion/react';

// Animation de pulsation pour le bouton
const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(249, 115, 22, 0);
  }
`;

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const toggleVisibility = () => {
      // Afficher le bouton quand on a scrollé plus de 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Zoom in={isVisible}>
      <Fab
        onClick={scrollToTop}
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          zIndex: 1000,
          background: theme.palette.color.degradeOne,
          color: 'white',
          width: 56,
          height: 56,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          animation: `${pulse} 2s ease-in-out infinite`,
          '&:hover': {
            background: theme.palette.color.degradeOne,
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 20px rgba(0,0,0,0.25)',
          },
          transition: 'all 0.3s ease',
          '@media (max-width: 600px)': {
            bottom: 24,
            right: 24,
            width: 48,
            height: 48,
          }
        }}
        aria-label="Remonter en haut"
      >
        <KeyboardArrowUp sx={{ fontSize: 28 }} />
      </Fab>
    </Zoom>
  );
};

export default ScrollToTopButton;

